import { Box, Card, Flex, Heading, Text } from '@radix-ui/themes';

interface TimingProps {
  duration_total_sec: number;
  duration_coach_sec: number;
  duration_student_sec: number;
  duration_coach_pct: number;
  duration_student_pct: number;
}

function formatDurationPretty(totalSeconds: number) {
  const s = Math.max(0, Math.floor(Number(totalSeconds) || 0));

  if (s < 60) return `${s}s`;

  const hours = Math.floor(s / 3600);
  const minutes = Math.floor((s % 3600) / 60);
  const seconds = s % 60;

  const pad2 = (n: number) => String(n).padStart(2, '0');

  if (hours === 0) {
    return `${pad2(minutes)}:${pad2(seconds)}`; // mm:ss
  }

  return `${pad2(hours)}:${pad2(minutes)}`; // hh:mm
}

export default function TimingBar({ timing }: {
  timing: TimingProps;
}) {
  return (<Card>
    <Heading size="4" mb="3">Conversation Timing</Heading>

    <Flex justify="between">
      <Box>
        <Text weight="bold" color="blue" size="2">
          Coach: {formatDurationPretty(timing.duration_coach_sec)} ({timing.duration_coach_pct}%)
        </Text>
      </Box>      
      <Box>
        <Text weight="bold" color="green" size="2">
          Student: {formatDurationPretty(timing.duration_student_sec)} ({timing.duration_student_pct}%)
        </Text>
      </Box>
    </Flex>
    <Box
      mb="2"
      style={{
        height: 12,
        borderRadius: 'var(--radius-6)',
        overflow: "hidden",
      }}
    >
      <Flex height="100%">
        <Box
          style={{
            width: `${timing.duration_coach_pct}%`,
            backgroundColor: "#2563eb", // blue
          }}
        />
        <Box
          style={{
            width: `${timing.duration_student_pct}%`,
            backgroundColor: "#16a34a", // green
          }}
        />
      </Flex>
    </Box>
    <Text weight="bold" as="div" align="center">
        Total: {formatDurationPretty(timing.duration_total_sec)}
      </Text>
    <Text
      size="1"
      color="gray"
      mt="2"
      as="p"
      style={{ fontStyle: "italic" }}
    >
      *Total duration represents the full conversation time between the first and last interaction,
      including pauses and silence. Coach and Student durations only include detected speaking time,
      so their sum may be lower than the total.
    </Text>
  </Card>)
}
